import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Simulacao } from '../../../interfaces/entities/SimuladorMensalidadeReajuste/Simulacao';
import { getSimulacao } from '../../../services/ContratoService';
import SimulationAdvice from './AvisoSimuladorMensalidadeReajuste';
import './styles.css';
import { sxTypographyAdvice, sxTypographyAdviceTitle } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import PageTitle from '../../../components/Accessibility/PageTitle';

const SimuladorMensalidadeReajuste: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(false);
  const [simuladorReajuste, setSimuladorReajuste] = useState<Simulacao>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const accessibility = useAccessibility();

  const fetchSimulation = async () => {
    setLoading(true);
    const response = await getSimulacao();
    if (response?.status === 200) {
      const simulationData: Simulacao = response.data;
      setSimuladorReajuste(simulationData);
    } else {
      console.error(response);
      openModalError('Erro ao consultar simulação', 'Ocorreu um erro ao consultar sua simulação. Tente novamente em instantes.');
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchSimulation();
  }, []);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  return (
    <>
      <div className='simulation-container'>
        <PageTitle text="Cálculo de mensalidade com aplicação de reajuste" marginBottom="24px" />
        {loading ? <LoadingApp showLoading={loading} /> :
          <>
            {!!simuladorReajuste?.mensagem ?
              <Typography style={accessibility.textStyleAccessibility}>{simuladorReajuste.mensagem}</Typography>
              :
              <>
                {!!simuladorReajuste?.rodape &&
                  <SimulationAdvice textoAviso={simuladorReajuste.rodape} />
                }
                <div className='simulation-items-holder'>
                  {simuladorReajuste?.lstVlrSimulacao.map((item) => (
                    !!item.valor.trim() &&
                    <div className='simulation-item'>
                      <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdviceTitle}>{item.text}</Typography>&nbsp;
                      <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdvice}>{item.valor}</Typography>
                    </div>
                  ))
                  }
                </div>
              </>
            }
          </>
        }
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default SimuladorMensalidadeReajuste;